import { render, staticRenderFns } from "./SponsorsDetails-new.vue?vue&type=template&id=01404cdc&scoped=true"
import script from "./SponsorsDetails-new.vue?vue&type=script&lang=js"
export * from "./SponsorsDetails-new.vue?vue&type=script&lang=js"
import style0 from "./SponsorsDetails-new.vue?vue&type=style&index=0&id=01404cdc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01404cdc",
  null
  
)

export default component.exports